module.exports = __webpack_public_path__ + "img/jpg.3a32d29e.svg";